export const manageDevices = {
	solicitationTypes: {
		permanent: "Permanente",
		temporary: "Temporal",
	},
	deviceListByPlace: {
		title: "Lista de equipos por lugar",
		totalDevices: "Total de equipos",
		table: {
			emptyState: {
				title: "Todavía no hay nada aquí",
			},
			columns: {
				contractStatus: "Estado del contrato",
				contractId: "ID de contrato",
				quantity: "Cantidad",
				serialNumber: "Número de serie",
				equipmentModel: "Modelo",
				requestType: "Tipo de solicitud",
			},
		},
		filters: {
			byContractId: "Filtrar por ID de contrato",
			bySerialNumber: "Filtrar por número de serie",
			byModel: "Filtrar por modelo",
			byStatus: "Filtrar por estado",
		},
		tag: {
			pendingSignature: "Firma pendiente",
			signatureExpired: "Firma vencida",
			contractExpired: "Contrato vencido",
			active: "Contrato activo",
			closed: "Contrato cerrado",
		},
		btnExport: "Exportar",
		requestEquipments: "Solicitar equipos",
	},
};
